
<div class="bell-area">
  <div class="notice-bell">
    <NotifierBadge :badge-count="unreadCount" class="badge" />
    <BasicLink :href="linkUrl">
      <FontAwesomeIcon :icon="['far', 'bell']" :style="styles" />
    </BasicLink>
  </div>
</div>
